import type {Logger} from '@feature-hub/core';
import type {FinanceParamsV1, LeasingParamsV1, PaymentConfigV1} from './v1.js';

export interface StorageData {
  readonly config?: PaymentConfigV1;
  readonly leasingParams?: LeasingParamsV1;
  readonly params?: FinanceParamsV1 | LeasingParamsV1;
}

const storageKey = `smart-payment-config-service-v1`;

const storage =
  typeof window === `undefined` ? undefined : window.sessionStorage;

export function writeToStorage(data: StorageData, logger: Logger): void {
  if (!storage) {
    return;
  }

  try {
    storage.setItem(storageKey, JSON.stringify(data));
  } catch (error) {
    logger.error(error);
  }
}

export function readFromStorage(logger: Logger): StorageData {
  if (!storage) {
    return {};
  }

  try {
    const stringifiedData = storage.getItem(storageKey);

    if (!stringifiedData) {
      return {};
    }

    return JSON.parse(stringifiedData);
  } catch (error) {
    logger.error(error);

    return {};
  }
}
